module.exports = __webpack_public_path__ + "img/img-chart-05.65b6059f.png";